var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.onlyRenderIfDeletable || _vm.state.deletable)?_c('button',{staticClass:"vue-fine-uploader-delete-button",attrs:{"type":"button","aria-label":"delete","disabled":!_vm.state.deletable || _vm.state.deleting},on:{"click":_vm._onClick}},[_vm._t("default",[_vm._v("Delete")])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb70dcee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-fineuploader/delete-button.vue
// module id = ND0a
// module chunks = 0